import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

/**
 * Confirmation dialog for deleting an order.
 */
export default function DeleteOrderDialog({
  open,
  onClose,
  onConfirm,
  order = null,
}) {
  const displayName = order
    ? order.order_number || order.product_name || "this order"
    : "this order";

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Order</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete <strong>{displayName}</strong>? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
